import { render, staticRenderFns } from "./LpuAffiliation.vue?vue&type=template&id=122697bc&"
import script from "./LpuAffiliation.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuAffiliation.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122697bc')) {
      api.createRecord('122697bc', component.options)
    } else {
      api.reload('122697bc', component.options)
    }
    module.hot.accept("./LpuAffiliation.vue?vue&type=template&id=122697bc&", function () {
      api.rerender('122697bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuAffiliation.vue"
export default component.exports